export const DefaultInternalCompanyName = "Internal";

export const DefaultNullCompanyName = "N/A";
